module.exports = __webpack_public_path__ + "img/IMG_3448.491310bd.jpeg";